angular
  .module('contributor')

  .factory('UpdateContributorsRatingsCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class UpdateContributorsRatingsCrud extends Crud {
        constructor() {
          super(null, '@@apiUrl' + '/set-contributors-last-rating', {}, {});
        }
      }
      return UpdateContributorsRatingsCrud;
    }
  ]);
